export default __webpack_public_path__ + "static/media/chevron-left.02f7b658.svg";